module.exports = __webpack_public_path__ + "img/logo_new.a971c92c.svg";